export default __webpack_public_path__ + "static/media/Slide16.0687d080.PNG";